module.exports = __webpack_public_path__ + "static/img/4-active.d89124c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/nav/4-active.png
// module id = p1G5
// module chunks = 0